import { render, staticRenderFns } from "./complaintGuide.vue?vue&type=template&id=2d87de8d"
import script from "./complaintGuide.vue?vue&type=script&lang=js"
export * from "./complaintGuide.vue?vue&type=script&lang=js"
import style0 from "./complaintGuide.vue?vue&type=style&index=0&id=2d87de8d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports